/**
 * Who may edit an event's Sales Reps list (event_sales_assignments). Mirrors the database rule
 * public.can_assign_event_sales_reps() (migration 2026-10-08-400, MSR plan round 9 D11): active full-time
 * employees — superadmin, admin, manager, staff, support_admin and support_agent. MSRs (part-time) and everyone else can see the list but gets no Assign / Remove controls,
 * because the database would refuse the write. Role spellings vary ('superadmin' vs 'super_admin').
 */
export function canAssignEventSalesReps(
  role: string | null | undefined,
): boolean {
  const r = (role ?? "").toLowerCase().replace(/_/g, "");
  return (
    r === "superadmin" ||
    r === "admin" ||
    r === "manager" ||
    r === "regionalmanager" ||
    r === "territorymanager" ||
    r === "staff" ||
    r === "supportadmin" ||
    r === "supportagent"
  );
}
